import { render, staticRenderFns } from "./VoyageList.vue?vue&type=template&id=2df4191c&"
import script from "./VoyageList.vue?vue&type=script&lang=js&"
export * from "./VoyageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports